import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import ResponsiveDrawer from "@/components/common/layout";

const ProtectedRoute = () => {
  const location = useLocation();
  let isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  const mustChangePassword =
    localStorage.getItem("passwordUpdateStatus") === "false";

  // ⛔️ Removed useAutoLogout (no timer-based logout)

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (mustChangePassword) {
    return <Navigate to="/changePasswordStatus" replace />;
  }

  if (location.pathname === "/") {
    return <Navigate to="/dashboard" replace />;
  }

  return <ResponsiveDrawer />;
};

export default ProtectedRoute;
